export default {
  LoginService: Symbol('LoginService'),
  OnboardingService: Symbol('OnboardingService'),
  AnonymousBookingsService: Symbol('AnonymousBookingsService'),
  NotificationService: Symbol('NotificationService'),
  TrackingService: Symbol('TrackingService'),
  LocaleService: Symbol('LocaleService'),
};
